import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Typography,
  Divider,
  Avatar,
} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import CartButton from '../Cart/CartButton';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { ENABLE_CHECKOUT } from '../../config/featureFlags';
import LogoutIcon from '@mui/icons-material/Logout';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const MobileDrawer = ({ navItems, location, navigate, onClose, isAuthenticated, user, logout }) => {
  return (
    <Box onClick={onClose} sx={{ textAlign: 'center' }}>
      <Typography variant="h6" sx={{ my: 2 }}>
        KBros Leather
      </Typography>
      <List>
        {navItems.map((item) => (
          <ListItem key={item.name} disablePadding>
            <ListItemButton
              sx={{
                textAlign: 'left',
                fontWeight: location.pathname === item.path ? 'bold' : 'normal',
                color: location.pathname === item.path ? '#f4a261' : 'inherit',
                paddingLeft: 2,
              }}
              onClick={() => navigate(item.path)}
            >
              <ListItemText primary={item.name} />
            </ListItemButton>
          </ListItem>
        ))}
        
        {ENABLE_CHECKOUT && (
          <>
            <Divider sx={{ my: 2 }} />

            {/* Authentication Section */}
            {isAuthenticated ? (
              <>
                <ListItem>
                  <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', pl: 2, py: 1 }}>
                    <Avatar
                      sx={{
                        width: 32,
                        height: 32,
                        bgcolor: '#8B4513',
                        fontSize: '0.875rem',
                        mr: 2
                      }}
                    >
                      {user?.firstName?.charAt(0) || user?.email?.charAt(0).toUpperCase() || 'U'}
                    </Avatar>
                    <Typography variant="subtitle1">
                      {user?.firstName ? `${user.firstName} ${user.lastName || ''}` : user?.email || 'User'}
                    </Typography>
                  </Box>
                </ListItem>

                <ListItem disablePadding>
                  <ListItemButton
                    sx={{ textAlign: 'left', paddingLeft: 2 }}
                    onClick={() => {
                      navigate('/account');
                      onClose();
                    }}
                  >
                    <ListItemIcon>
                      <AccountCircleIcon sx={{ color: '#8B4513' }} />
                    </ListItemIcon>
                    <ListItemText primary="My Account" />
                  </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                  <ListItemButton
                    sx={{ textAlign: 'left', paddingLeft: 2 }}
                    onClick={() => {
                      navigate('/account/orders');
                      onClose();
                    }}
                  >
                    <ListItemIcon>
                      <ShoppingBagIcon sx={{ color: '#8B4513' }} />
                    </ListItemIcon>
                    <ListItemText primary="My Orders" />
                  </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                  <ListItemButton
                    sx={{ textAlign: 'left', paddingLeft: 2 }}
                    onClick={() => {
                      navigate('/account/addresses');
                      onClose();
                    }}
                  >
                    <ListItemIcon>
                      <LocationOnIcon sx={{ color: '#8B4513' }} />
                    </ListItemIcon>
                    <ListItemText primary="My Addresses" />
                  </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                  <ListItemButton
                    sx={{ textAlign: 'left', paddingLeft: 2 }}
                    onClick={() => {
                      logout();
                      onClose();
                      navigate('/');
                    }}
                  >
                    <ListItemIcon>
                      <LogoutIcon sx={{ color: '#8B4513' }} />
                    </ListItemIcon>
                    <ListItemText primary="Logout" />
                  </ListItemButton>
                </ListItem>
              </>
            ) : (
              <>
                <ListItem disablePadding>
                  <ListItemButton
                    sx={{ textAlign: 'left', paddingLeft: 2 }}
                    onClick={() => {
                      navigate('/login');
                      onClose();
                    }}
                  >
                    <ListItemIcon>
                      <AccountCircleIcon sx={{ color: '#8B4513' }} />
                    </ListItemIcon>
                    <ListItemText primary="Login / Register" />
                  </ListItemButton>
                </ListItem>
              </>
            )}

            <Divider sx={{ my: 2 }} />

            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 2 }}>
              <CartButton />
            </Box>
          </>
        )}
      </List>
    </Box>
  );
};

MobileDrawer.propTypes = {
  navItems: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
    })
  ).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  navigate: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool,
  user: PropTypes.object,
  logout: PropTypes.func,
};

MobileDrawer.defaultProps = {
  isAuthenticated: false,
  user: null,
  logout: () => {},
};

export default MobileDrawer;
